<template>
    <div class="fwht">
        <div class="fwhtcontent">
            <div class="title">
                {{list.title}}
            </div>
            <div class="fu">
                <span>{{list.publishDate}}</span>
            </div>
            <div class="neirong">
                <div class="lunbo">
                    <van-swipe :autoplay="3000">
                        <van-swipe-item>
                            <a>
                                <img :src="list.webUrl" width="100%" height="100%"/>
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <p>{{list.content}}</p>
            </div>
            
        </div>
        <div style="height:50px;width:100%"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list:{}
        }
    },
    created () {
        var that = this
        that.$toast.loading({
            message: '加载中...',	//加载的时候显示的文字
            duration:0,//展示时长(ms)，值为 0 时，toast 不会消失
            overlay:true,//是否显示遮罩层
            forbidClick: true//是否禁止背景点击
        })
    },
    mounted() {
        this.getdata(this.$route.query.id)
    },
    methods: {
        getdata(id){
            var that = this
            that.$axios.get('/api/v1/wygl/ownersHomePage/viewone',{
                params:{
                    webUrlId:id
                }
            }).then(result=>{
                that.$toast.clear()
                console.log(result)
                that.list = result
            })
        },

    },
}
</script>
<style lang="less" scoped>
    .fwht{
        overflow: hidden;
        .fwhtcontent{
            margin: 5%;
            display: flex;
            flex-direction: column;
            align-items: center;
            
            .title{
                font-size: 20px;
                font-weight: bold;
            }
            .lunbo {
                // margin-bottom: 5px;
                height: 28vh;
                padding: 10px 10px 10px 10px;
                .van-swipe{
                    height: 100%;
                }
            }
            .fu{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                font-size: 14px;
                margin: 10px 0;
            }
            .neirong{
                width: 100%;
                img{
                    width: 100%;
                    margin-top: 10px;
                }
            }
            p{
                margin: 0;
                padding: 0;
                text-indent: 2rem;
                line-height: 30px;
                font-size: 15px;
            }
        }
    }
</style>